// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__HrubL","iconContainer":"Sidebar_iconContainer__bktVw","active":"Sidebar_active__AF0gR","icon":"Sidebar_icon__wQ6Mc"};